import {cn} from '../../../../classname';

export const cnGptDialogPresetList = cn('gpt-dialog-preset-list');
